export default "__VITE_ASSET__31820d92__"